module.exports = __webpack_public_path__ + "static/media/thorntons.58bbf58d.png";